


























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { cloneDeep, get } from 'lodash-es'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faSave, faTimes } from '@fortawesome/free-solid-svg-icons'
import constants from '@/utils/constants';
import apiPathConst from '@/api/modules/apiPath'
import Autocomplete from '@/components/Autocomplete.vue';

library.add(faBars, faSave, faTimes)

@Component({
  components: {
    Autocomplete,
  },
})
export default class UserPopup extends Vue {
  @Prop({ default: false }) showModal?: boolean;
  @Prop() data!: any;

  $swal: any;
  apiPathConst: any = apiPathConst
  isChanged: boolean = false;
  obj: any = {
    userId: '',
    contact: {
      email: '',
      phone: '',
      name: '',
    },
    user: {
      userId: '',
      customerName: '',
      phoneNumber: '',
    },
    phoneNumber: '',
  };

  get updateOrderDetail() {
    return this.$store.getters.GetUpdateOrderDetail;
  }

  @Watch('updateOrderDetail.isSuccess')
  watchOrderDetailSuccess() {
    if (this.updateOrderDetail.isSuccess) {
      const payload: any = {
        orderId: this.data.orderId,
        ...this.obj,
      };
      const newUserId = get(this.updateOrderDetail, 'detail.userIdNew', '');
      if (newUserId) {
        payload.userId = newUserId;
        payload.user = {
          ...this.obj.user,
          userId: newUserId,
        };
      }
      this.$store.commit('UPDATE_ORDER_DETAIL', payload);
      this.$emit('call-back', payload);
      this.$swal(
        constants.SUCCESS_MESSAGE,
        'Order Updated',
        constants.STATUS_SUCCESS
      );
    }
  }

  @Watch('updateOrderDetail.error')
  watchOrderDetailError() {
    if (this.updateOrderDetail.error) {
      this.$swal(
        constants.SOMETHING_WROING,
        this.updateOrderDetail.error,
        constants.STATUS_ERROR
      );
    }
  }

  reset() {
    this.isChanged = false;
    this.obj = {
      userId: this.data.userId,
      contact: cloneDeep(this.data.contact),
      user: cloneDeep(this.data.user),
    };
  }

  discardModal() {
    this.reset();
    this.$emit('discard-modal');
  }

  selectPhone(item) {
    this.obj.phoneNumber = item.phoneNumber;
    this.obj.contact.phone = item.phoneNumber;
    this.obj.contact.name = item.name;
    this.obj.user.phoneNumber = item.phoneNumber;
    this.obj.user.customerName = item.name;
    this.isChanged = true;
  }

  saveData() {
    if (this.updateOrderDetail.isUpdating) return;
    this.$validator.validateAll().then(async(valid) => {
      if (valid) {
        this.$store.dispatch('UpdateOrderDetail', {
          orderId: this.data.orderId,
          userInfo: {
            phoneNumber: this.obj.contact.phone,
          }
        });
      }
    })
  }
};
